import { EnumValues } from 'enum-values';

export const enumValues = <E extends Record<string, string>>(
  enumeration: E,
): E[keyof E][] => EnumValues.getValues(enumeration) as E[keyof E][];

export const enumNames = <E extends Record<string, string>>(
  enumeration: E,
): Extract<keyof E, string>[] =>
  EnumValues.getNames(enumeration) as Extract<keyof E, string>[];
